import {
  type AccountStatus,
  type AccountStatusSource,
  deriveAccountStatus,
} from '@repo/api-contracts';

export type { AccountStatusSource };

/**
 * 클라이언트 계정 상태 파생 — 구현은 @repo/api-contracts 의 공유 함수다.
 *
 * 서버(액세스 토큰 페이로드 파생)와 같은 판정을 쓰도록 계약 패키지로 승격했다 —
 * 두 벌 구현이면 판정 규칙 변경 시 컴파일러가 불일치를 잡지 못한다.
 * users.me 응답에는 status 필드가 없으므로 클라이언트는 이 함수로 파생한다.
 * 본인인증 사용 여부는 서버 설정이라 users.me 의 identityRequired 를 그대로 넘긴다.
 */
export const deriveClientAccountStatus = (
  me: AccountStatusSource & { readonly identityRequired: boolean },
): AccountStatus => deriveAccountStatus(me, { identityRequired: me.identityRequired });
